// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"progress__wrapper__2ilV9","progress":"progress__progress__22NLZ"};